import { LogEntry } from './logEntry';

export class ErrorLogEntry extends LogEntry {
  stackTrace?: any;
  srcStackTrace?: any;
  extraInfo?: any;
  processState?: any;
}
